export default __webpack_public_path__ + "static/media/Trasnsportation-cap60.74929db1.jpeg";